import { ApiError } from "@vana/core";

export class GetDeliveryDetailError extends ApiError {}

export class ListAmbassadorsError extends ApiError {}

export class ListAddressesError extends ApiError {}

export class ReassignDeliveryError extends ApiError {}

export class RescheduleDeliveryError extends ApiError {}
